import { createCalendarVisitSchedule } from '../calendarVisitSchedule.schema';
import { NORMALIZED_KEYS } from '../visitScheduleStep.reducer';

/**
 * Normalizes an array of CalendarVisitSchedule objects into a normalized map keyed by padVisitId.
 */
export const normalizeCalendarVisitSchedule = calendarVisitScheduleArray => {
  const byPadVisitId = {};
  calendarVisitScheduleArray.forEach(calendarVisitSchedule => {
    const { id = null } = calendarVisitSchedule.padVisit || {};

    if (id) {
      byPadVisitId[id] = createCalendarVisitSchedule(calendarVisitSchedule);
    }
  });
  return {
    [NORMALIZED_KEYS.IDS]: Object.keys(byPadVisitId).map(Number),
    [NORMALIZED_KEYS.BY_PAD_VISIT_ID]: byPadVisitId
  };
};
